import { useEffect, useRef } from 'react';
import { useAdminInbox } from '../context/AdminInboxContext';
import { useAuth } from '../context/AuthContext';
import { bindFcmForegroundListener, registerFcmOnDashboard } from '../services/fcmPush';

const FcmMessaging = () => {
  const { isAuthenticated, loading } = useAuth();
  const { addFromFcmPayload } = useAdminInbox();
  const started = useRef(false);

  useEffect(() => {
    if (loading || !isAuthenticated || started.current) return;
    started.current = true;

    let unsubscribeForeground = () => {};

    const onSwMessage = (event) => {
      if (event.data?.type === 'FCM_NOTIFICATION') {
        addFromFcmPayload(event.data.payload);
      }
    };

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', onSwMessage);
    }

    (async () => {
      try {
        await registerFcmOnDashboard();
      } catch (err) {
        console.warn('FCM registration failed:', err);
      }
      try {
        unsubscribeForeground = await bindFcmForegroundListener();
      } catch (err) {
        console.warn('FCM foreground listener failed:', err);
      }
    })();

    return () => {
      unsubscribeForeground();
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener('message', onSwMessage);
      }
    };
  }, [isAuthenticated, loading, addFromFcmPayload]);

  return null;
};

export default FcmMessaging;
